<template>
    <v-dialog
        v-model="$store.state.dispatch.adviceDlg"
        width="800px"
    >
        <v-card>
            <v-toolbar color="secondary" dark dense>
                <v-spacer></v-spacer>
                Advices  {{order}}
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.dispatch.adviceDlg = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container class="px-4">
               <v-row>
                <v-col v-if="text.stationDT.length > 0 ">
                    <v-card>
                    <v-toolbar color="primary" dark dense>
                        <v-spacer></v-spacer>
                        Station: {{text.stationDT[0].station.Name}}
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-container grid-list-xs fluid>
                        {{text.stationDT[0].Advice}}
                    </v-container>
                </v-card>
                </v-col>
                <div v-else></div>
                <v-col v-if="text.terminalDT.length > 0 ">
                    <v-card>
                    <v-toolbar color="primary" dark dense>
                        <v-spacer></v-spacer>
                        Terminal: {{text.terminalDT[0].terminal.TerminalName}}
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-container grid-list-xs fluid>
                        {{text.terminalDT[0].Advice}}
                    </v-container>
                </v-card>
                </v-col>
                <div v-else></div>
               </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
    
export default {
    props:['text','order'],
    
    data: function() {
        return {
            title:'',
        }
    },
    async mounted() {
        console.log(this.text);
    },
}
</script>
